/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/minigame-wrapper/minigame-wrapper-trick-or-treat',['require','underscore','screens/minigame-wrapper/minigame-wrapper'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var MiniGameWrapper = require('screens/minigame-wrapper/minigame-wrapper');

  /*****************************************************************************************************************///}

  var MiniGameWrapperTrickOrTreat = MiniGameWrapper.extend({

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      //console.log('MiniGameWrapperTrickOrTreat::initialize');
      MiniGameWrapper.prototype.initialize.apply(this, arguments);
    },

    startGame: function()
    {
      //console.log('start game called');
      var sceneIndex = this.page.get('sceneIndex');
      var sceneArr = this.miniGameData.scenes;
      var newSceneIndex = sceneIndex || _.random(0, sceneArr.length - 1);
      while (newSceneIndex === sceneIndex)
      {
        newSceneIndex = _.random(0, sceneArr.length - 1);
      }

      this.miniGameData.sceneIndex = newSceneIndex;
      //console.log('new scene index: ', newSceneIndex);
      //console.log('this.miniGameData: ', this.miniGameData);
      //console.log('this.miniGameData: ', this.miniGameData.sceneIndex);
      this.page.set('sceneIndex', newSceneIndex);

      MiniGameWrapper.prototype.startGame.apply(this, arguments);
    }

  /*****************************************************************************************************************///}

  });

  return MiniGameWrapperTrickOrTreat;

});

